module.exports = __webpack_public_path__ + "static/Premium_tradycyjne_wew-4328c7a7330697009d93e4bae6c3764b.png";